import React, { useState, Fragment} from "react";
import { Container, Row, Col, Button} from "react-bootstrap";
import ObjectsService from "../services/objects.service";
import SolutionService from "../services/solution.service";
import { useUser } from "../context/UserContext";
import AsaService from "../services/asa.service";


export default function ObjectPicker (data){

   const [objects, setObjects] = useState([]);
   const [errorSubmit, setErrorSubmit] = useState("");
   const { asaData } = useUser();

   const limit = data.limit;
   const problemid = data.pb.problemid;
   const ordernum = data.pb.ordernum;

   if(!limit){
      limit = 1;
   }

   const onSubmitButton = async () => {

      try {
        setErrorSubmit("");
        const response = await ObjectsService.getRandomObjects(limit);
        setObjects(response.data); 
     } catch (errorSubmit) {
        setErrorSubmit(errorSubmit.response?.data.message);
     }
  };

const handleCompleteButtonClick = async () => {

   let objstr = objects.reduce((objstr, obj) => `${objstr} ${obj.objectname}, `, "Objects: " );

   try {
     setErrorSubmit("");  
     const solid = await SolutionService.addSolutionByProblem(problemid, objstr);    
     setErrorSubmit("Task Completed! Refresh page to start the next task");

     if(asaData){
      var datatosend = asaData;
      datatosend.step_number = ordernum + 1;
      const asaresp = await AsaService.sendTaskCompletion(datatosend);
      console.log("ASA Task Response: ", asaresp)
    } 
  } catch (errorSubmit) {  
     setErrorSubmit(errorSubmit.response?.data.message);
  }

};



    return (
      <Container className="m-3 p-3 border border-rounded border-secondary">
         
         {!objects[0] ? 
               (<Row>
                  <Col className="col-12">
                     <Button variant="primary" type="submit" onClick={() => onSubmitButton()}>
                                 Pick A Random Object
                     </Button>  
                  </Col>
               </Row>)
               :
               (<>
                  <Row>
                     <Col className="col-12">
                        <p className="text-danger"> <strong> Random Objects: </strong> </p>
                        {
                           objects.map((obj) => (<p>{obj.objectname}</p>))
                        }
                     </Col>
                  </Row>
                  
                  {errorSubmit && (
                     <Row className="text-danger">
                        {errorSubmit}
                     </Row>
                  )}  

                  {!errorSubmit && (
                      <Row>
                        <Col className="col-12 col-md-6">
                           <Button variant="primary" type="submit" onClick={() => handleCompleteButtonClick()}>
                                       Use this Object and Complete Task
                           </Button> 
                           
                        </Col>
                        <Col className="col-12 col-md-6">
                           <Button variant="secondary" type="submit" onClick={() => onSubmitButton()}>
                                       Regenerate Random Object
                           </Button> 
                           
                        </Col>
                     </Row>
                  )} 
               </>)
         }      

   </Container>
  
    )

}
